/** Shared open state so header dropdown and empty-home CTA can open one modal. */
export const claimServerModal = $state({ open: false })
